// extracted by mini-css-extract-plugin
export default {"highlighter":"Review_highlighter__3oY8s"};